import React, { useEffect, useState } from "react"
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable"
import PunchIcon from "../../assets/images/timesheet.png"
import PunchLogs from "./PunchLogs"
import secureLocalStorage from "react-secure-storage"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import moment from "moment"
import Loader from "pages/Separate/Loader"
import { Modal } from "reactstrap"
import TimesheetReport from "pages/Elements/Dashboard/TimesheetReport"

const Timesheet = () => {
  const [ticketList, setTicketList] = useState(false)
  const [openOption, setOpenOption] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  const [logs, setLogs] = useState([])
  const [previousDate, setPreviousDate] = useState("")
  const userId = localStorage.getItem("auth_id")
  const token = secureLocalStorage.getItem("auth_token")

  const syncTimerState = async () => {
    const today = moment().format("YYYY-MM-DD")

    const res = await fetchNodeData(
      setLoading,
      `wfhpunch/${userId}/${today}`,
      token
    )

    if (!res?.status) return

    const logs = res.punchLogs || []
    const count = logs.length

    if (count % 2 !== 0) {
      const lastPunch = logs[count - 1]

      const punchTime = lastPunch.punch_time
      const punchDate = new Date(`${today} ${punchTime}`)

      localStorage.setItem("isTimer", "true")
      localStorage.setItem("startTime", punchDate.getTime())
      localStorage.setItem("startDate", punchDate.toISOString())
    } else {
      setOpenOption(false)
      localStorage.setItem("isTimer", "false")
      localStorage.removeItem("startTime")
    }
  }

  //   }, [])

  useEffect(() => {
    syncTimerState()
  }, [])

  useEffect(() => {
    if (isOpen) syncTimerState()
  }, [isOpen])

  useEffect(() => {
    localStorage.setItem("isTimer", openOption)
  }, [openOption])


  return (
    <div>
      {isLoading && <Loader />}
      <Draggable handle=".floating-button">
        <div className={`floating-container timesheet ${isOpen ? "show" : ""}`}>
          <div
            className={`floating-button timer ${openOption ? "timer-on" : ""} `}
            onClick={() => setIsOpen(!isOpen)}
          >
            <div className="pulse"></div>
            <div className="position-absolute w-100 h-100"></div>

            <img src={PunchIcon} alt="Bug" width={32} height={32} />
          </div>
          {isOpen ? (
            <div className="element-container">
              <Modal
                size="xl"
                isOpen={isOpen}
                centered
                toggle={() => {
                  setIsOpen(isOpen)
                }}
                className="modal-fullscreen"
              >
                <TimesheetReport setIsOpen={setIsOpen} />
              </Modal>
            </div>
          ) : null}
        </div>
      </Draggable>

      <div className={`note-sticky-form ${ticketList ? "d-block" : "d-none"}`}>
        <Draggable handle=".modal-header" cancel=".modal-body">
          <ResizableBox
            width={900}
            style={{
              position: "fixed",
              top: "18%",
              right: "15%",
              zIndex: "999",
              backgroundColor: "#fff",
              maxHeight: "fit-content",
              transform: "translate(-50%, -50%)",
            }}
          >
            <div className="modal-header ">
              <h5 className="modal-title mt-0">Today's Punch Logs</h5>
              <button
                type="button"
                onClick={() => {
                  setTicketList(false)
                }}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  &times;
                </span>
              </button>
            </div>
            <PunchLogs data={logs} />
          </ResizableBox>
        </Draggable>
      </div>
    </div>
  )
}

export default Timesheet
